import { render, staticRenderFns } from "./chat-message-search-form-result-item.vue?vue&type=template&id=46c28746&scoped=true"
import script from "./chat-message-search-form-result-item.vue?vue&type=script&lang=ts"
export * from "./chat-message-search-form-result-item.vue?vue&type=script&lang=ts"
import style0 from "./chat-message-search-form-result-item.vue?vue&type=style&index=0&id=46c28746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c28746",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
